import TomSelect from 'tom-select';

export default function initTomSelect() {
    const config = {
        create: false,
        sortField: {
            field: "text",
            direction: "asc"
        }
    };

    if (document.querySelector('#tom-select-it')) {
        console.log('tom select init');
        new TomSelect('#tom-select-it', config);
    }
}
